// The five TuneWatch avatars. Flat, rounded, friendly — One UI feeling.
// Only the id is ever stored in Firestore (users/{uid}.avatarId); the artwork
// lives in the client. No uploads, no cropping, no camera.
export const AVATARS = [
  { id: "wave", name: "Wave", bg: "#E3F0FF", fg: "#0077FF" },
  { id: "bloom", name: "Bloom", bg: "#F1E9FF", fg: "#7C3AED" },
  { id: "ember", name: "Ember", bg: "#FFEEDC", fg: "#D97706" },
  { id: "leaf", name: "Leaf", bg: "#E1F5EC", fg: "#059669" },
  { id: "blush", name: "Blush", bg: "#FFE8F1", fg: "#DB2777" },
];

export const DEFAULT_AVATAR_ID = AVATARS[0].id;

export function getAvatar(avatarId) {
  return AVATARS.find((avatar) => avatar.id === avatarId) || null;
}
